// Etiquetas, colores y formato de una liquidación. Viven aquí y no en
// LiquidacionesPage porque la ficha del propietario muestra las suyas con la
// misma lectura: si el color de un modelo o el nombre de un estado de pago
// cambia en Contabilidad, tiene que cambiar también allí.

export const MODEL_LABELS: Record<string, string> = {
  gestion: 'Gestión',
  explotacion_lcm: 'Explotación LCM',
  explotacion: 'Explotación',
  explotacion_sin_irpf: 'Explotación s/IRPF', // legacy
  rent2rent: 'Rent2Rent',
};

export const MODEL_COLORS: Record<string, string> = {
  gestion: 'bg-blue-50 text-blue-700 border-blue-200',
  explotacion_lcm: 'bg-amber-50 text-amber-700 border-amber-200',
  explotacion: 'bg-amber-50 text-amber-700 border-amber-200',
  explotacion_sin_irpf: 'bg-amber-50 text-amber-700 border-amber-200', // legacy
  rent2rent: 'bg-purple-50 text-purple-700 border-purple-200',
};

export const PAYMENT_STATUS: Record<string, { label: string; className: string }> = {
  none: { label: 'Pendiente', className: 'bg-amber-100 text-amber-800 border-amber-300' },
  pending: { label: 'Procesando', className: 'bg-amber-50 text-amber-700 border-amber-200' },
  processing: { label: 'Procesando', className: 'bg-amber-50 text-amber-700 border-amber-200' },
  completed: { label: 'Pagado', className: 'bg-green-50 text-green-700 border-green-200' },
  failed: { label: 'Error', className: 'bg-red-50 text-red-700 border-red-200' },
};

export const paymentStatusOf = (liq: any) =>
  PAYMENT_STATUS[liq?.paymentStatus || 'none'] || PAYMENT_STATUS.none;

/** Los modelos de explotación emiten factura; el resto, liquidación. */
export const docLabel = (liq: any) => (liq?.result?.tipo === 'factura' ? 'factura' : 'liquidación');

export const fmt = (n: number) =>
  new Intl.NumberFormat('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + ' €';

/**
 * Un saldo negativo es a favor de Sereno: lo paga el propietario (va en la
 * factura de Sereno) y no hay nada que transferirle. Pasa, por ejemplo, con
 * un mes en el que solo hay una estancia del propietario.
 */
export const saldoAFavorDeSereno = (saldo: unknown) => Number(saldo) < 0;

/** «a favor del propietario» o «a favor de Sereno», según el signo del saldo. */
export const aFavorDe = (saldo: unknown) => (saldoAFavorDeSereno(saldo) ? 'a favor de Sereno' : 'a favor del propietario');

const MESES_CORTOS = ['En', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'];

/**
 * «Sept 2026» en vez de «Septiembre 2026», para el listado, donde el mes
 * completo partía la celda en dos líneas. PDFs, correos y la ficha siguen con
 * el nombre completo (`liq.periodo`).
 */
export const periodoCorto = (liq: any): string =>
  liq?.month >= 1 && liq?.month <= 12 && liq?.year ? `${MESES_CORTOS[liq.month - 1]} ${liq.year}` : String(liq?.periodo ?? '');
